import React from 'react'
import { useNavigate } from 'react-router-dom'
import TrashExplorer from '@/components/Trash/TrashExplorer'

export default function TrashContent() {
  const navigate = useNavigate()

  const handleBackToDashboard = () => {
    navigate('/dashboard')
  }

  return <TrashExplorer onBack={handleBackToDashboard} />
}
